import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Meta } from "../../Components/Helpers/Meta";
import { Navbar } from "../../Components/Navbar/Navbar";
import PdfViewer from "./PdfViewer";
import "./StakeholderEngagementPlan.css";

const StakeholderEngagementPlan = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const language = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const pdfUrl = `${process.env.PUBLIC_URL}/static/docs/stakeholder-engagement-plan-${language === "tr" ? "tr" : "en"}.pdf`;
  const title = t("stakeholder-engagement-plan");

  return (
    <div>
      <Meta title={title} description={title} lang={lang} />
      <Navbar />
      <main className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <img
              className="c-hero-image"
              alt=""
              src={require("../../assets/hero/sustainability-report.93d2f60c.jpg")}
            />
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div
                className="c-caption-section"
                style={{ color: "#fff", textAlign: "center" }}
              >
                {t("sustainability")}
              </div>
              <h1 className="c-caption-header">{title}</h1>
            </div>
          </div>
        </div>
        <div className="c-container stakeholder-engagement-plan">
          <a className="c-button" href={pdfUrl} target="_blank" rel="noopener noreferrer">
            {t("stakeholder-engagement-plan-open-pdf")}
          </a>
          <PdfViewer key={pdfUrl} file={pdfUrl} title={title} />
        </div>
      </main>
    </div>
  );
};

export default StakeholderEngagementPlan;
